import {BehaviorSubject, Observable} from "rxjs";
import {User} from "../model/user";


export abstract class AuthService {
  redirectUrl: string = '/reserved';
  protected _internalUser?: User;
  protected behaviorUser: BehaviorSubject<User | undefined> = new BehaviorSubject<User | undefined>(undefined);

  abstract login(): void;
  abstract logout(): void;
  abstract refreshUser?(): void;
  abstract changePassword(oldPass: string, newPass: string): Observable<void>;
  abstract clearUser?(): void;
  abstract getToken(): Observable<string>;

  public loggedUser(): User | undefined {
    return this._internalUser;
  }

  public onUserChange(): Observable<User | undefined> {
    return this.behaviorUser.asObservable();
  }

}
